<template>
  <div class="activity-product-list">
    <activity-nav-list class="activity-nav-list" v-model="formInfo.country" :list="productCountryList" :show-option-all="true" v-if="activityInfo.enabled_country_filter && productCountryList.length"></activity-nav-list>
    <div class="product-list">
      <div 
        class="product-item" 
        v-for="(product, productIndex) in filterProductList" 
        :key="productIndex">
        <activity-product-item :product="product" @clickProduct="(event) => jumpToProduct(product)"></activity-product-item>
      </div>
    </div>
  </div>
</template>


<script>
import ActivityNavList from '@/components/activity/index-activity/activity-nav-list.vue';
import ActivityProductItem from '@/components/activity/index-activity/activity-product-item.vue';
import sensorsdata from 'sa-sdk-javascript';
import sensorService from '@/services/sensor-service';
import { mapMutations } from 'vuex';
import User from '../../../libs/user';

export default {
  components: {
    ActivityNavList,
    ActivityProductItem,
  },
  props: {
    productList: {
      type: Array,
      default: () => [],
    },
    provinceCode: {
      type: Number,
      default: 0,
    },
    activityInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      User,
      formInfo: {
        country: 0,
      },
    };
  },
  computed: {
    filterProductList() {
      const productList = this.productList || [];
      let filterProductList = productList;
      if (this.formInfo.country) {
        filterProductList = productList.filter(item => item.country === this.formInfo.country);
      }
      return filterProductList;
    },
    productCountryList() {
      const productList = this.productList || [];
      const allProductCountryList = productList.map(item => item.country);
      // 去重
      return [...new Set(allProductCountryList)];
    },
  },
  watch: {
    productList: {
      handler(val) {
        // 重新请求需要重置国家
        this.formInfo.country = 0;
      },
    },
  },
  methods: {
    ...mapMutations(['SHOW_LOGIN_BOX']),
    jumpToProduct(product) {
      if (this.User.isLogin()) {
        sensorsdata.track('SalesPromotionClick', {
          product_id: product.visa_product_id,
          product_name: product.product_name,
          click_source: 'SalesPromotion',
        });
        // 商详神策埋点page_from字段
        const pageFrom = sensorService.getPageFrom('电子签列表页');
        this.$router.push({ name: 'product', params: { visa_product_id: parseInt(product.visa_product_id, 10) }, query: { from: 'activity', province_code: this.provinceCode, ...pageFrom } });
      } else {
        this.SHOW_LOGIN_BOX({ from: 'activity' });
      }
    },
  },

};
</script>


<style lang="less" scoped>
.activity-product-list {
  display: flex;
  flex-direction: column;
  width: 1120px;
  margin: 0 auto;
  .activity-nav-list {
    margin-bottom: 16px;
  }
  .product-list {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: -20px;
    .product-item {
      width: 360px;
      margin: 0 0 20px 20px;
      &:nth-child(3n+1){
        margin: 0 0 20px 0;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/activity/components/activity-product-list.vue